import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DomainBrandService } from '@services/domain-brand.service';
// import { environment } from '../../../environments/environment.prod';
@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
})
export class FormsComponent implements OnInit {
  public frmSend: FormGroup;
  @Input() type: string;
  bgImage: any = './assets/img/contactbg2';
  url: string;
  submitted: boolean = false;
  isLoading: boolean = false;
  messageSending: string;
  messageSendingType: boolean;

  constructor(
    private _fb: FormBuilder,
    private _http: HttpClient,
    public brand: DomainBrandService
  ) { }

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el
   * -------------------------------------------------------
   */
  ngOnInit(): void {
    this.initFormArray();
  }

  /**
   * -------------------------------------------------------
   * @summary loadFormArray
   * @description Recorrer la posicion de objects de un form y los carga en el
   * formArray con form builder
   * -------------------------------------------------------
   */
  initFormArray() {
    this.frmSend = this._fb.group({
      fcn_fullname: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50),],],
      fcn_email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),],],
      fcn_message: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(250),],],
    });
  }

  /**
   * -------------------------------------------------------
   * @summary invalidValue
   * @description Retorna si se ha hecho touch  o si el estatus es invalid en un formControlName
   * @param {string} fcname - formControlName
   * -------------------------------------------------------
   */
  invalidValue(fcname: string) {
    return this.frmSend.get(fcname).invalid && this.frmSend.get(fcname).touched;
  }

  /**
   * -------------------------------------------------------
   * @summary getLength
   * @description obtiene el lenght
   * @param {string} fcname - formControlName
   * @param {FormGroup} fgroup - formControlName
   * -------------------------------------------------------
   */
  getLength(fgroup: FormGroup, fcname: string) {
    return fgroup.get(fcname).value?.length;
  }

  /**
   * -------------------------------------------------------
   * @summary setMessage
   * @description Recibe y asigna el mensaje a mostrar
   * @param {string} msj - Mensaje a mostrar
   * @param {boolean} type - Tipo de mensaje
   * -------------------------------------------------------
   */
  setMessage(msj: string, type: boolean) {
    this.messageSending = msj;
    this.messageSendingType = type;
  }

  /**
   * -------------------------------------------------------
   * @summary validateForm
   * @description Valida si el formulario es invalido
   * @param {string} fcname - formControlName
   * -------------------------------------------------------
   */
  validateForm() {
    if (this.frmSend.invalid) {
      return Object.values(this.frmSend.controls).forEach((control) => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach((control) =>
            control.markAsTouched()
          );
        } else {
          control.markAsTouched();
        }
      });
    }
  }


  /**
   * -------------------------------------------------------
   * @summary onKeydown
   * @description Reconec la tecla enter y la bloquea
   * @param {event} event - Evento capturado
   * -------------------------------------------------------
   */
  onKeydown(event) {
    // if (event.key === 'Enter') {
    //   event.preventDefault();
    // }
  }

  /**
   * -------------------------------------------------------
   * @summary sendForm
   * @description Envio de formulario
   * @param {string} typeForm - Tipo de formulario
   *
   * -------------------------------------------------------
   */
  sendForm(data, typeForm: string) {
    switch (typeForm) {
      case 'contact':
        this.url = `http://dev.sigmaindustrial.com/assets/mail/mail_contact.php`;
        this.validateForm();
        this.onSubmit(this.frmSend, this.url);
        break;
    }
  }

  /**
   * -------------------------------------------------------
   * @summary onSubmit
   * @description Validacion para envio de formulario final
   * @param {FormGroup} fgroup - formGrop
   * @param {string} url - url de archivo php
   * -------------------------------------------------------
   */
  onSubmit(fgroup: FormGroup, url: string) {
    // console.log(`fgroup`, fgroup);
    // console.log(`fgroup.status`, fgroup.status);
    // console.log(`this.submitted`, this.submitted)
    // console.log(`this.isLoading`, this.isLoading)
    if (fgroup.status == 'VALID') {
      fgroup.disable(); // Se deshabilita el formulario para evitar doble envio
      this.isLoading = true; // Status del proceso iniciado
      this.submitted = false; // Status de mensaje de respuetas del envio
      this._http.post(url, fgroup.value, { responseType: 'text' }).subscribe(
        (response) => {
          if (response === 'true') {
            this.setMessage('Solicitud enviada!', true);
          } else {
            this.setMessage(
              'Error en el envio de solicitud, dominio del correo no existente',
              false
            );
          }
          // console.log(`response`, response);
          this.submitted = true; // Status de mensaje de respuetas del envio
          this.isLoading = false; // Status del proceso finalizado
          // Habilita el formulario para el envio
          setTimeout(() => {
            this.submitted = false; // Status de mensaje de respuetas del envio
            fgroup.enable(); // Se habilita el formulario para el envio
            // fgroup.reset(); // Se limpian todos los campos
          }, 3000);
        },
        (error) => {
          this.setMessage(
            'Error en el envio de solicitud, intente nuevamente',
            false
          );
          this.submitted = true; // Status de mensaje de respuetas del envio
          this.isLoading = false; // Status del proceso finalizado
          // Habilita el formulario para el envio
          setTimeout(() => {
            this.submitted = false; // Status de mensaje de respuetas del envio
            fgroup.enable(); // Se habilita el formulario para el envio
            // fgroup.reset(); // Se limpian todos los campos
            console.warn(`error => `, error);
          }, 3000);
        }
      );
    }
  }
}
